import React, {Component} from 'react'
import fire from '../../../../../database/firebase'
import styled from 'styled-components'
import { GridLoader } from 'react-spinners'

const Container = styled.div`
    width: 100%;
    height: auto;
    background-color: #321d05;
    //   padding: 1%;
    position: relative; /* Position relative to contain the dropdown */
    text-align: right;
    border-bottom: 0.5px solid white;
    padding-bottom: 2%;
`;

const Button = styled.button`
    background-color: #007bff;
    color: #fff;
    padding-left: 4%;
    padding-right: 4%;
    cursor: pointer;
    padding-top: 0px;
    padding-bottom: 0px;
    margin-right: 3.5%;
    background-color: #321d05;
    border-radius: 8px;
    border: 1px solid white;
    margin-top: 4%;
`;

const Dropdown = styled.div`
    position: absolute;
    top: 100%; /* Position the dropdown below the button */
    left: 0;
    width: 96%; /* Expand the dropdown to the full width of the container */
    display: ${props => (props.open ? 'block' : 'none')}; /* Show/hide the dropdown */
    background-color: #321d05;
    color: #fff;
    padding: 10px;
    //   border: 0.7px solid white;
    border-top: 1px solid white;
    border-bottom: 1px solid white;
    font-family: sora;
    // border-bottom-left-radius: 10px;
    // border-bottom-right-radius: 10px;
    transition: max-height 0.3s ease-in, opacity 0.3s ease-in; /* Add transitions */
    max-height: ${props => (props.open ? '200px' : '0')}; /* Set max-height for smooth expansion and collapse */
    overflow: hidden; /* Hide overflow content */
    opacity: ${props => (props.open ? '1' : '0')}; /* Set opacity for fade-in and fade-out */
`;

const Styles = styled.div `

    // - - FULL PAGE - - //

.fullPage {
    width: 100%;
    height: auto;
}

    // - - - NAVBAR - - //

.menu-btn {
    width: 25px;
    height: 25px;
}

    // - - - - - REWARDS PAGE - - - - - //

.wishListPage {
    margin-top: 2.5%;
}

    // - - REWARDS PAGE HEADER - - //

.wishListPageHeader h1 {
    margin-left: 2%;
    font-family: sora;
}

.wishListPageHeader button {
    height: 50px;
    width: 55px;
    margin-right: 3.5%;
    border: 2px solid black;
    border-radius: 8px;
    margin-top: 2.5%;
    background-color: white;
    font-size: 25px;
    color: black;
    display: flex; /* Use Flexbox */
    justify-content: center; /* Center horizontally */
    align-items: center; /* Center vertically */  
    padding-bottom: 1%;
}

.wishListPageHeader button:hover {
    color: white;
    background-color: #0930cb;
    border: 2px solid #0930cb;
}

    // - - REWARDS PAGE LOADING - - //

.wishListPageLoading {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 75vh; /* This will make the container take the full viewport height */
    text-align: center;
}

`

export default class WishListSmPhone extends Component {
    constructor() {
        super()
        this.state = {
            userID: "",
            phoneNumber: "",
            currentClient: "",
            placeholderText: "",
            showWishListPage: false,
            showWishListPageLoading: true
        }
    }

    componentDidMount = () => {
        const url = window.location.href
        const parts = url.split('/'); // Split the URL by '/'
        const lastPart = parts[parts.length - 1]; // Get the last part
        this.setState({
            currentClient: lastPart
        })
        this.loadWishListPage(lastPart)
    }

    loadWishListPage = (client) => {
        fire.auth().onAuthStateChanged((user) => {
            if (user) {
                fire.firestore().collection("clients")
                .doc(client)
                .collection("members")
                .doc("members_list")
                .collection("email_list")
                .doc(user.email)
                .get().then(doc => {
                    if (doc.exists) {
                        this.setState({
                            userID: doc.data().id,
                            phoneNumber: doc.data().number
                        })
                        this.loadDatabaseInformation(client, doc.data().id)
                    }
                })
            } else {
                console.log("We failed dawg")
                this.setState({user:null})
            }
        })
        this.setState({
            showWishListPageLoading: true
        }, () => {
            setTimeout(() => {
               this.setState({
                showWishListPageLoading: false,
                showWishListPage: true
               })
            }, 2500)
        })
    }

    loadDatabaseInformation = (client, userID) => {
        fire.firestore().collection("clients")
        .doc(client)
        .collection("members")
        .doc("members_list")
        .collection("list")
        .doc(userID)
        .collection("data")
        .doc("wishList")
        .collection("list")
        .doc("placeholder")
        .get().then(doc => {
            if (doc.exists) {
                this.setState({
                    placeholderText: doc.data().text
                })
            }
        })
    }

    toggleDropdown = () => {
        this.setState((prevState) => ({
          isDropdownOpen: !prevState.isDropdownOpen,
        }));
    };

    exitWishListPage = () => {
        this.setState({
            showWishListPage: false,
            showWishListPageLoading: true
        }, () => {
            setTimeout(() => {
               this.setState({
                showWishListPageLoading: false,
               })
               window.location.href = `/home/${this.state.currentClient}`
            }, 2500)
        })
    }

    render () {
        return (
            <Styles>
                <div className='fullPage'>
                    <div className='navbar'>
                        <Container>
                            <div style={{display: "flex", justifyContent:"space-between"}}>
                                <h3 style={{paddingLeft: "4%", fontFamily: "sora", fontSize: "18.5px", fontWeight: "bold", paddingTop: "2%", color: "white"}}>Wish List <label style={{marginLeft: "5px"}}>💫</label></h3>
                                <Button onClick={this.toggleDropdown}>
                                    <img className='menu-btn' src='/assets/mobile-smallphone-menu-icon.png'/>
                                </Button>
                            </div>
                            <Dropdown open={this.state.isDropdownOpen}>
                            <p style={{paddingRight: "2.5%"}}>Logout</p>
                            <p style={{paddingRight: "2.5%"}}>Back to Home</p>
                            {/* <p style={{paddingRight: "2.5%"}}>Rewards</p>
                            <p style={{paddingRight: "2.5%"}}>More Options</p> */}
                            </Dropdown>
                        </Container>
                    </div>
                    {this.state.showWishListPage && 
                        <div className='wishListPage'>
                            <div style={{display: "flex", justifyContent:"space-between"}} className='wishListPageHeader'>
                                <h1>Wish List</h1>
                                <button
                                onClick={this.exitWishListPage}
                                >⬅︎</button>
                            </div>
                        </div>
                    }
                    {this.state.showWishListPageLoading && 
                        <div className='wishListPageLoading'>
                            <GridLoader
                            color="#321d05"
                            loading={true}
                            // cssOverride={override}
                            size={7.5}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                            />
                        </div>
                    }
                </div>
            </Styles>
        )
    }
}